import { render, staticRenderFns } from "./subCateView.vue?vue&type=template&id=19b830a8&scoped=true&"
import script from "./subCateView.vue?vue&type=script&lang=js&"
export * from "./subCateView.vue?vue&type=script&lang=js&"
import style0 from "./subCateView.vue?vue&type=style&index=0&id=19b830a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b830a8",
  null
  
)

export default component.exports